import React, {createElement, useContext, useEffect, useState} from 'react';
import {ReactComponent as WalkIcon} from '../../assets/icons/map/walk.svg';
import {getTimeDistance} from '../../core/utils';
import {MapContext} from '../../services/map-v2/map.context';


import './time-walk.scss';

export const TimeWalkComponent = ({
    coords,
    size = 'm',
}: {
    coords: google.maps.LatLngLiteral,
    size?: 's' | 'm' | 'l'
}) => {

    const {pointer, ready} = useContext(MapContext);
    const [time, setTime] = useState<number>(0);

    useEffect(() => {
        if (ready) {
            setTime(getTimeDistance(pointer, coords));
        }
    }, [ready, pointer, coords]);

    return <div className={`time-walk ${size}`}>
        {createElement(WalkIcon)}
        {`${time} min`}
    </div>;
};
